import 'bootstrap/dist/css/bootstrap.min.css';
import React, {lazy, Suspense, useEffect} from 'react';
import {createBrowserRouter, createRoutesFromElements, Navigate, Route, RouterProvider} from 'react-router-dom';
import {GlobalProvider, ProtectedRouteProvider} from './providers';
import {
    HomeLayoutComponent
} from './components';
import {LoadingComponent} from './components';
import {
    AuthenticationLayoutComponent,
} from './components/layout/authentication_layout/authenticationLayout.component';

const HomePage = lazy(() => import('./pages/home').then((module) => ({
    default: module.HomePage,
})));
const OurServicePage = lazy(() => import('./pages/services').then((module) => ({
    default: module.ServicesPage,
})));
const VoucherPage = lazy(() => import('./pages/voucher').then((module) => ({
    default: module.VoucherPage,
})));
const GenerateVoucherPage = lazy(() => import('./pages/voucher').then((module) => ({
    default: module.GenerateSection,
})));
const RedeemVoucherPage = lazy(() => import('./pages/voucher').then((module) => ({
    default: module.RedeemSection,
})));
const WalletPage = lazy(() => import('./pages/wallet').then((module) => ({
    default: module.WalletPage,
})));
const UserTransactionsPage = lazy(() => import('./pages/transactions').then((module) => ({
    default: module.TransactionsPage,
})));
const SettingsPage = lazy(() => import('./pages/settings').then((module) => ({
    default: module.SettingsPage,
})));
const NotificationSettingsPage = lazy(() => import('./pages/settings').then((module) => ({
    default: module.NotificationsComponent,
})));
const GeneralSettingsPage = lazy(() => import('./pages/settings').then((module) => ({
    default: module.GeneralComponent,
})));
const EditAccountPage = lazy(() => import('./pages/settings').then((module) => ({
    default: module.EditAccountComponent,
})));
const BeneficiariesAccountPage = lazy(() => import('./pages/settings').then((module) => ({
    default: module.BeneficiariesComponent,
})));
const SecuritySettingsPage = lazy(() => import('./pages/settings').then((module) => ({
    default: module.SecurityComponent,
})));
const ChangePinPage = lazy(() => import('./pages/settings').then((module) => ({
    default: module.ChangePinComponentAction,
})));
const ChangePasswordPage = lazy(() => import('./pages/settings').then((module) => ({
    default: module.ChangePasswordComponentAction,
})));
const SignInPage = lazy(() => import('./pages/signIn').then((module) => ({
    default: module.SignInPage,
})));
const SignUpPage = lazy(() => import('./pages/signUp').then((module) => ({
    default: module.SignUpPage,
})));
const VerifyOtpPage = lazy(() => import('./pages/verifyOtp').then((module) => ({
    default: module.VerifyOtpPage,
})));
const ForgotPasswordPage = lazy(() => import('./pages/forgotPassword').then((module) => ({
    default: module.ForgotPasswordPage,
})));
const VerifyForgotPasswordOtpPage = lazy(() => import('./pages/forgotPassword').then((module) => ({
    default: module.ForgotPasswordVerifyOtpPage,
})));
const NotFoundPage = lazy(() => import('./pages/notFound').then((module) => ({
    default: module.NotFoundPage,
})));
const SetPinPage = lazy(() => import('./pages/setPin').then((module) => ({
    default: module.SetPinPage,
})));


const router = createBrowserRouter(
    createRoutesFromElements(
        <Route element={<Suspense fallback={<LoadingComponent/>}>
            <GlobalProvider/>
        </Suspense>}>
            <Route element={<ProtectedRouteProvider/>}>
                <Route path={'/'} element={<HomeLayoutComponent/>}>
                    <Route element={<HomePage/>} index/>
                    <Route path={'settings'} element={<SettingsPage/>}>
                        <Route index element={<Navigate replace to={"account"}/>}/>
                        <Route index path={'account'} element={<EditAccountPage/>}/>
                        <Route path={'notification'} element={<NotificationSettingsPage/>}/>
                        <Route path={'security'}>
                            <Route index element={<Navigate replace to={"update-password"}/>}/>
                            <Route path={'change-pin'} element={<ChangePinPage/>}/>
                            <Route path={'update-password'} element={<ChangePasswordPage/>}/>
                        </Route>
                        <Route path={'beneficiaries'} element={<BeneficiariesAccountPage/>}/>
                        <Route path={'general'} element={<GeneralSettingsPage/>}/>
                    </Route>
                    <Route path={"services"} element={<OurServicePage/>}/>
                    <Route path={"wallet"} element={<WalletPage/>}/>
                    <Route path={"voucher"} element={<VoucherPage/>}>
                        <Route index element={<Navigate replace to={"./generate"}/>}/>
                        <Route path={"generate"} element={<GenerateVoucherPage/>}/>
                        <Route path={"redeem"} element={<RedeemVoucherPage/>}/>
                    </Route>
                    <Route path={"user-transactions"} element={<UserTransactionsPage/>}/>
                </Route>
                <Route path={'/set-pin'} element={<SetPinPage/>}/>
            </Route>
            <Route element={<AuthenticationLayoutComponent/>}>
                <Route path={'/sign-in'} element={<SignInPage/>}/>
                <Route path={'/register'} element={<SignUpPage/>}/>
                <Route path={'/verify-otp'} element={<VerifyOtpPage/>}/>
                <Route path={'/forgot-password'} element={<ForgotPasswordPage/>}/>
                <Route path={'/forgot-password/verify'} element={<VerifyForgotPasswordOtpPage/>}/>
            </Route>
            <Route path={"*"} element={<NotFoundPage/>}/>
        </Route>
    ),
);

function App() {
    return <RouterProvider router={router}/>
}

export default App;
